import React from 'react';
//import moment from 'moment'

export default class GetAge extends React.Component {
    
    constructor() {
        super();
    
        this.state = {
          componentData: ''
        };
      }

  componentDidMount() {
    var today = new Date();
    var birthDate = new Date(this.props.birth);
    //console.log(birthDate);
    var age = today.getFullYear() - birthDate.getFullYear();
    //console.log(age);
    var m = today.getMonth() - birthDate.getMonth();
    //console.log(m);
    var d = today.getDate() - birthDate.getDate();
    //console.log(d);

    if (m < 0 ) {
      age--;
      //console.log(age);
      this.setState({
        componentData: age
      })
    }

    if ((m == 0) && (d < 0) ) {
      age--;
      //console.log(age);
      this.setState({
        componentData: age
      })
    }

    if ((m == 0) && (d > 0) ) {
      this.setState({
        componentData: age
      })
    }

    if (m > 0) {
      this.setState({
        componentData: age
      })
    }
    

    
  }

  render() {
    return (
      <>
        <span>{this.state.componentData}</span>
      </>
    )
  }
}